import React, { useEffect } from "react";
import "./cardNoResumen.scss";
import { Link, useNavigate } from "react-router-dom";
import Logo from "../../../resources/img/icono-publicaciones.png";

const MisActosAdminCard = () => {
  useEffect(() => { }, []);
  const navigate = useNavigate();
  return (



    <section className="temas">
      <Link to="/misActosAdmin"
      title="Mis actos administrativos"
      aria-label="Mis actos administrativos"
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault()
          navigate("/misActosAdmin")
        }
      }}
      >
        <div className="card-caja-mini temas card m-4 h-auto">
          <div className="tituloAccesibilidad d-flex align-items-center">
              <img

            alt="IRPF"
            src={Logo}
          />
            <h3 className="tituloAccesibilidad ms-2">Consulta de mis actos administrativos</h3>
          </div>

          {/* <span className="mx-4">Convocatorias Abiertas para solicitar.</span> */}
          <span className="mx-4 fw-light">Consulta de mis actos administrativos.</span>
          {/*<p style={{ marginTop: "auto", textAlign: "right" }}>
 <Link to="/carrera">
    <ButtonCardMini nombre="Acceder" clases="btn-card" />
  </Link>
</p>*/}

        </div>
      </Link>
    </section>
  );
};
export default MisActosAdminCard;